import analysis from '@/assets/svg/icon-analysis.svg';
import arrowBlack from '@/assets/svg/icon-arrow-black.svg';
import arrowWhite from '@/assets/svg/icon-arrow-white.svg';
import arrow from '@/assets/svg/icon-arrow.svg';
import battery from '@/assets/svg/icon-battery.svg';
import blueBattery from '@/assets/svg/icon-blue-battery.svg';
import blueComputer from '@/assets/svg/icon-blue-computer.svg';
import blueDashboard from '@/assets/svg/icon-blue-dashboard.svg';
import blueIncome from '@/assets/svg/icon-blue-income.svg';
import blueLedger from '@/assets/svg/icon-blue-ledger.svg';
import blueNote from '@/assets/svg/icon-blue-note.svg';
import bluePlus from '@/assets/svg/icon-blue-plus.svg';
import blueReceived from '@/assets/svg/icon-blue-received.svg';
import blueRotate from '@/assets/svg/icon-blue-rotate.svg';
import blueSignal from '@/assets/svg/icon-blue-signal.svg';
import blueTowerCrane from '@/assets/svg/icon-blue-tower-crane.svg';
import bulb from '@/assets/svg/icon-bulb.svg';
import bus from '@/assets/svg/icon-bus.svg';
import call from '@/assets/svg/icon-call.svg';
import carbonAccount from '@/assets/svg/icon-carbon-account.svg';
import carbonCredit from '@/assets/svg/icon-carbon-credit.svg';
import care from '@/assets/svg/icon-care.svg';
import certification from '@/assets/svg/icon-certification.svg';
import charge from '@/assets/svg/icon-charge.svg';
import circle from '@/assets/svg/icon-circle.svg';
import circularEnergy from '@/assets/svg/icon-circular-energy.svg';
import cleanEnergy from '@/assets/svg/icon-clean-energy.svg';
import clinic from '@/assets/svg/icon-clinic.svg';
import co2 from '@/assets/svg/icon-co2.svg';
import compatible from '@/assets/svg/icon-compatible.svg';
import completeCertification from '@/assets/svg/icon-complete-certification.svg';
import compliance from '@/assets/svg/icon-compliance.svg';
import cost from '@/assets/svg/icon-cost.svg';
import cots from '@/assets/svg/icon-cots.svg';
import credit from '@/assets/svg/icon-credit.svg';
import customization from '@/assets/svg/icon-customization.svg';
import day1 from '@/assets/svg/icon-day1.svg';
import deployment from '@/assets/svg/icon-deployment.svg';
import disaster from '@/assets/svg/icon-disaster.svg';
import economic from '@/assets/svg/icon-economic.svg';
import energyConsume from '@/assets/svg/icon-energy-consume.svg';
import energyIndependence from '@/assets/svg/icon-energy-independence.svg';
import energyManage from '@/assets/svg/icon-energy-manage.svg';
import energy from '@/assets/svg/icon-energy.svg';
import enhanced from '@/assets/svg/icon-enhanced.svg';
import facebook from '@/assets/svg/icon-facebook.svg';
import flexibility from '@/assets/svg/icon-flexibility.svg';
import flexible from '@/assets/svg/icon-flexible.svg';
import grayBattery from '@/assets/svg/icon-gray-battery.svg';
import greenBattery from '@/assets/svg/icon-green-battery.svg';
import greenEarth from '@/assets/svg/icon-green-earth.svg';
import greenEnergy from '@/assets/svg/icon-green-energy.svg';
import hightStability from '@/assets/svg/icon-hight-stability.svg';
import hospital from '@/assets/svg/icon-hospital.svg';
import increase from '@/assets/svg/icon-increase.svg';
import instagram from '@/assets/svg/icon-instagram.svg';
import install from '@/assets/svg/icon-install.svg';
import intelligent from '@/assets/svg/icon-intelligent.svg';
import internet from '@/assets/svg/icon-internet.svg';
import inverter from '@/assets/svg/icon-inverter.svg';
import largeHospital from '@/assets/svg/icon-large-hospital.svg';
import lca from '@/assets/svg/icon-lca.svg';
import lightning from '@/assets/svg/icon-lightning.svg';
import linkedIn from '@/assets/svg/icon-linkedIn.svg';
import list from '@/assets/svg/icon-list.svg';
import location from '@/assets/svg/icon-location.svg';
import logistics from '@/assets/svg/icon-logistics.svg';
import paper from '@/assets/svg/icon-paper.svg';
import payback from '@/assets/svg/icon-payback.svg';
import photovoltaicEnergy from '@/assets/svg/icon-photovoltaic-energy.svg';
import power from '@/assets/svg/icon-power.svg';
import process from '@/assets/svg/icon-process.svg';
import rapidIncrease from '@/assets/svg/icon-rapid-increase.svg';
import reduce from '@/assets/svg/icon-reduce.svg';
import reliability from '@/assets/svg/icon-reliability.svg';
import reliable from '@/assets/svg/icon-reliable.svg';
import roadMap from '@/assets/svg/icon-road-map.svg';
import safety from '@/assets/svg/icon-safety.svg';
import sbti from '@/assets/svg/icon-sbti.svg';
import schoolBus from '@/assets/svg/icon-school-bus.svg';
import service from '@/assets/svg/icon-service.svg';
import size from '@/assets/svg/icon-size.svg';
import solution from '@/assets/svg/icon-solution.svg';
import streetLamp from '@/assets/svg/icon-street-lamp.svg';
import sustainabilityPro from '@/assets/svg/icon-sustainability-pro.svg';
import sustainability from '@/assets/svg/icon-sustainability.svg';
import thermal from '@/assets/svg/icon-thermal.svg';
import time from '@/assets/svg/icon-time.svg';
import warranty from '@/assets/svg/icon-warranty.svg';
import waterPump from '@/assets/svg/icon-water-pump.svg';

export const icons = {
  analysis,
  arrowBlack,
  arrowWhite,
  arrow,
  battery,
  blueBattery,
  blueComputer,
  blueDashboard,
  blueIncome,
  blueLedger,
  blueNote,
  bluePlus,
  blueReceived,
  blueRotate,
  blueSignal,
  blueTowerCrane,
  bulb,
  bus,
  call,
  carbonAccount,
  carbonCredit,
  care,
  certification,
  charge,
  circle,
  circularEnergy,
  cleanEnergy,
  clinic,
  co2,
  compatible,
  completeCertification,
  compliance,
  cost,
  cots,
  credit,
  customization,
  day1,
  deployment,
  disaster,
  economic,
  energyConsume,
  energyIndependence,
  energyManage,
  energy,
  enhanced,
  facebook,
  flexibility,
  flexible,
  grayBattery,
  greenBattery,
  greenEarth,
  greenEnergy,
  hightStability,
  hospital,
  increase,
  instagram,
  install,
  intelligent,
  internet,
  inverter,
  largeHospital,
  lca,
  lightning,
  linkedIn,
  list,
  location,
  logistics,
  paper,
  payback,
  photovoltaicEnergy,
  power,
  process,
  rapidIncrease,
  reduce,
  reliability,
  reliable,
  roadMap,
  safety,
  sbti,
  schoolBus,
  service,
  size,
  solution,
  streetLamp,
  sustainabilityPro,
  sustainability,
  thermal,
  time,
  warranty,
  waterPump
};